import React, {Fragment, useEffect} from 'react';
import {Tabs, PlusButton} from '../../../components';
import {Route, Switch} from 'react-router-dom';
import WebIcon from '@material-ui/icons/Web';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ShortTextIcon from '@material-ui/icons/ShortText';
import Checklists from './Sections/CheckLists';
import Quizzes from './Sections/Quizzes';
import Documents from './Sections/Documents';
import SalesCoachSetup from './Sections/SalesCoachSetup';


export default function SalesCoachSection(props){

  return(
    <Fragment>
      <Tabs {...props} white tabs={[{title:'Settings', path:'/sales_coach/setup'}, {title:'Documents', path:'/sales_coach/documents'}, {title:'Checklists', path:'/sales_coach/checklists'}, {title:'Quizzes', path:'/sales_coach/quizzes'}]}/>
      <Switch>
        <Route path='/sales_coach/quizzes'render={(route)=><Quizzes {...route} {...props}/>}/>
        <Route path='/sales_coach/checklists'render={(route)=><Checklists {...route} {...props}/>}/>
        <Route path='/sales_coach/documents'render={(route)=><Documents {...route} {...props}/>}/>
        <Route path='/sales_coach/setup' render={(route)=><SalesCoachSetup {...route}{...props}/>}/>
      </Switch>
    </Fragment>
  );
}
